import styled from '@emotion/styled';
import { Button } from 'semantic-ui-react';
import { useNavigate } from 'react-router';

/**
 * Page component with a default 401 page
 */
export const NoAccess = ({
  title = '401',
  text = 'You cannot access this page.',
}: {
  title?: string;
  text?: string;
}) => {
  const navigate = useNavigate();
  return (
    <S.Container>
      <div className="content">
        <S.H1>{title}</S.H1>
        <S.H2>{text}</S.H2>

        <Button onClick={() => navigate(-1)}>Go back</Button>
      </div>
    </S.Container>
  );
};

const S = {
  Container: styled.div`
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    color: #aaa;
  `,

  H1: styled.h1`
    font-weight: 900;
    font-size: 165px;
    line-height: 1;
    margin-bottom: -10px;
    opacity: 0.6;
  `,

  H2: styled.h2`
    font-weight: 700;
    font-size: 34px;
    margin-bottom: 20px;
    opacity: 0.9;
  `,
};
